// DS1.15
import React from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../Avatar';
import UserLink from '../Link';
import s from './UserIdentity.scss';
var UserIdentity = function (_a) {
    var size = _a.size, user = _a.user, timestamp = _a.timestamp, className = _a.className;
    return (React.createElement(Flex, { className: classnames(s[size], timestamp && s['with-timestamp'], className), alignItems: "center" },
        React.createElement(UserAvatar, { user: user, className: s['avatar'], size: size === 'small' ? 24 : 32 }),
        React.createElement("div", { className: s['details'] },
            React.createElement(UserLink, { user: user, className: s['userlink'] }),
            timestamp && React.createElement("div", { className: s['timestamp'] }, timestamp))));
};
UserIdentity.displayName = 'UserIdentity';
export default UserIdentity;
//# sourceMappingURL=UserIdentity.js.map